import { Suspense, lazy } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AdminAuthProvider } from '@/lib/admin-auth'
import { RouteBoundary } from '@/lib/route-boundary'

const FormPage = lazy(() => import('@/features/form/form-page'))
const AdminLayout = lazy(() => import('@/features/admin/admin-layout'))
const AdminLogin = lazy(() => import('@/features/admin/admin-login'))
const AdminVerify = lazy(() => import('@/features/admin/admin-verify'))
const AdminSubmissions = lazy(() => import('@/features/admin/admin-submissions'))
const AdminSubmissionDetail = lazy(() => import('@/features/admin/admin-submission-detail'))

function DefaultRedirect() {
  return <Navigate to="/nyscc-2026" replace />
}

export default function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <RouteBoundary>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<DefaultRedirect />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="/admin/submissions" replace />} />
                <Route path="login" element={<AdminLogin />} />
                <Route path="verify" element={<AdminVerify />} />
                <Route path="submissions" element={<AdminSubmissions />} />
                <Route path="submissions/:id" element={<AdminSubmissionDetail />} />
              </Route>
              <Route path="/:formId" element={<FormPage />} />
            </Routes>
          </Suspense>
        </RouteBoundary>
      </AdminAuthProvider>
    </BrowserRouter>
  )
}

function LoadingFallback() {
  return (
    <main className="mx-auto flex min-h-screen max-w-2xl items-center justify-center px-6">
      <p style={{ color: 'var(--color-text-muted)' }}>Loading…</p>
    </main>
  )
}
